<template>
	<div style="overflow-x: hidden !important">
		<div class="main">
			<div style="padding: 10px; margin-top: 15px">
				<div class="header">
					<div class="header_title-container title">
						<h1>{{ $t("wizards") }}</h1>
					</div>
					<div class="header_actions">
						<div class="header_actions-container">
							<el-input v-model="filters.name" @input="debounceInput" />
						</div>
					</div>
				</div>
			</div>
			<div :style="{ height: height + 'px' }" style="overflow-y: auto">
				<md-table :key="updateID" v-model="wizards">
					<md-table-row @click="openWizard(wizard.id)" slot="md-table-row" slot-scope="{ item: wizard }">
						<!-- Title -->
						<md-table-cell :md-label="$t('title').toUpperCase()">
							{{ wizard.name }}
						</md-table-cell>
						<!-- Created at -->
						<md-table-cell :md-label="$t('updated-at').toUpperCase()">
							{{ new Date(wizard.updated_at).toLocaleString("it-IT", { timezone: "UTC" }) }}
						</md-table-cell>
						<md-table-cell :md-label="$t('category').toUpperCase()">
							{{ $t(wizard.type) }}
						</md-table-cell>
						<!-- Edit -->
						<!--				<md-table-cell>-->
						<!--					<el-button 	v-if="user && user.organization.id === '1'"-->
						<!--						@click="showEditTicket(true, ticket.id)"-->
						<!--						type="primary"-->
						<!--						icon="el-icon-edit"-->
						<!--						circle-->
						<!--					></el-button>-->
						<!--				</md-table-cell>-->
						<md-table-cell>
							<el-button
								v-if="wizard.id != 1 && wizard.id != 2"
								@click="
									event => {
										event.stopImmediatePropagation()
										todeleteid = wizard.id
									}
								"
								type="danger"
								icon="el-icon-delete"
								circle
							></el-button>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<el-dialog :title="$t('warning')" :visible.sync="centerDialogVisible" width="30%" center>
				<span>{{ $t("are-you-sure-to-delete-wizard") }}</span>
				<span slot="footer" class="">
					<el-button @click="centerDialogVisible = false">{{ $t("cancel") }}</el-button>
					<el-button type="primary" @click=";(centerDialogVisible = false), deleteWizard(todeleteid)"
						>OK</el-button
					>
				</span>
			</el-dialog>
			<el-dialog :title="$t('warning')" :visible.sync="cannotdelete" width="30%" center>
				<span>{{ $t("cannot-delete-wizard") }}</span>
				<span slot="footer" class="">
					<el-button @click="cannotdelete = false">{{ $t("cancel") }}</el-button>
				</span>
			</el-dialog>

			<app-pagination :tot="total" :size="pagination.size" :offset="pagination.offset" @fetch="fetchWizards" />
		</div>
	</div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex"
import { uuid } from "@/modules/builder/utils/utils"
import AppPagination from "@/modules/_common/table/app-pagination"
import { goto } from "@/utils/utils"
import axios from "axios"
export default {
	name: "wizard-all",

	async created() {
		this.openLoad()
		await this.initPage()
	},
	components: {
		AppPagination
	},

	computed: {
		...mapState("wizard", ["pagination", "total", "wizards"])
	},
	watch: {
		todeleteid() {
			if (this.todeleteid)
				axios
					.post(
						process.env.VUE_APP_API_URL + "/api/wizard/get/" + this.todeleteid,
						{},
						{
							headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
						}
					)
					.then(res => {
						if (res.data.parents) {
							this.cannotdelete = true
							this.todeleteid = undefined
						} else this.centerDialogVisible = true
					})
					.catch(err => {
						this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
					})
		}
	},

	data: () => ({
		height: window.innerHeight - 320,
		centerDialogVisible: false,
		cannotdelete: false,
		todeleteid: undefined,
		addTicketDialog: false,
		editTicketDialog: false,
		ticketMessagesDialog: false,
		selectedTicket: {},
		filters: {
			name: ""
		},
		connection: undefined,
		updateID: uuid()
	}),
	methods: {
		goto,
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			closeLoad: "modules/CLOSE_LOADING"
		}),
		...mapActions({
			getTickets: "wizard/loadWizards",
			filterWizards: "wizard/filterWizards",
			doMutate: "wizard/doMutate",
			loadWizards: "wizard/loadWizards"
		}),
		async initPage() {
			this.openLoad()
			this.loadWizards()
			this.closeLoad()
		},

		debounceInput: _.debounce(function () {
			this.fetchWizards()
		}, 200),

		fetchWizards(page, size) {
			var f = { ...this.pagination }
			if (size) f.size = size
			if (page) f.offset = (page - 1) * this.pagination.size
			this.doMutate({ element: "pagination", value: f })

			const filters = Object.fromEntries(Object.entries(this.filters).filter(([key, value]) => value))
			this.filterWizards({ ...filters, name: `%${this.filters.name}%`, pagination: f })
		},
		openWizard(id) {
			this.goto("/wizards/" + id)
		},
		deleteWizard(id) {
			axios
				.delete(process.env.VUE_APP_API_URL + "/api/wizard/" + id, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.openLoad()
					this.loadWizards()
					this.closeLoad()
				})
				.catch(err => {
					this.$processError(this.$t("delete-error"), err.response.data.Message)
				})
		}
	}
}
</script>
<style scoped></style>
